import { EnrolmentRequestInformation } from './../../_models/EnrolmentRequestInformation';
import { Enrolment } from './../../_models/enrolment';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ResultData } from 'src/app/_models/ResultData';
import { StudentRegData } from 'src/app/_models/registration/StudentRegData';
import { CountryService } from 'src/app/_services/country.service';
import { LevelService } from 'src/app/_services/level.service';
import { StudentService } from 'src/app/_services/student.service';
import { SubjectService } from 'src/app/_services/subject.service';
import { Guardian } from './../../_models/guardian';
declare var $ : any;
@Component({
  selector: 'app-register-student',
  templateUrl: './register-student.component.html',
  styleUrls: ['./register-student.component.css']
})

export class RegisterStudentComponent implements OnInit {
  enrolment = new Enrolment()
  countries = []
  curriculums = []
  levels = []
  subjects = []
  errorSaving=false
  registering=false
  @Input() guardian= new Guardian()
  @Output() closeModalRequest = new EventEmitter<string>()
  @Output()  notificationRegFinished = new EventEmitter<string>()

  myForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
    curriculum: new FormControl('', [Validators.required]),
    level: new FormControl('', [Validators.required])
  });
  constructor(
    private studentService:StudentService,
    private countryService:CountryService,
    private levelService:LevelService,
    private subjectService:SubjectService) { }
    get f(){
      return this.myForm.controls
    }

  ngOnInit(): void {

    this.errorSaving=false
    this.countryService.getCountriesIdAndName().subscribe(
      x=>{this.countries= x }
    )
    this.levelService.getCurriculums().subscribe(
    {next:(data:ResultData)=>{this.curriculums= data.rs.data },error:(err)=>{console.log("error getting curriculums",err)}
  })
  }
  on_submit(){
    let  eInfo= new EnrolmentRequestInformation()
    eInfo.server_guardian_id=this.guardian.server_guardian_id
    this.registering=true
    for (let i = 0; i < this.subjects.length; i++) {
    let dd= new StudentRegData()
    dd.firstname=this.myForm.value.firstName
    dd.lastname=this.myForm.value.lastName
    dd.server_country_id=this.myForm.value.country
    dd.server_curriculum_id=this.myForm.value.curriculum
    dd.server_level_id=this.myForm.value.level
    dd.reference_id=this.studentService.generatePaymentOrderId()
    dd.paymentOrderId=dd.reference_id
    dd.server_subject_id=this.subjects[i].id
    eInfo.settlement_choice.payment_info.paymentOrderId=dd.reference_id
    eInfo.settlement_choice.payment_info.amount=0
    eInfo.requests.push(dd)
  }
    this.studentService.registerEnrolStudent(eInfo).subscribe(
      {
        next:(data:ResultData)=>{{
          this.enrolment=data.rs.data
          if(this.enrolment.server_enrolment_id==0){
            this.errorSaving=true
            this.notificationRegFinished.emit("FAILED")
          }
          else{
            this.closeModal()
            this.registering=false
            this.notificationRegFinished.emit("SUCCESS")


          }
        }

      }
      ,error:(err)=>{
        console.error("Error registering student",err)
        this.registering=false
        this.errorSaving=true
        this.notificationRegFinished.emit("FAILED")
      }
    }


    )
  }
  onCurriculumOptionsSelected(value: number) {
    this.levelService.getLevelIdAndNameByCurriculum(value).subscribe(
      {next:(data:ResultData)=>{
        this.levels = data.rs.data
       },error:(err)=>{
        console.error("Error Retrieving Level and name By Country", err)
       }

          }
        )
      }

  onLevelOptionsSelected(value: number) {
    this.subjectService.getSubjectsIdAndNameByLevel(value).subscribe(
      {next:(data:ResultData)=>{
        this.subjects = data.rs.data
      },error:(err)=>{
        console.error("Error retrieving subject by level",err)
      }
      }
    )
  }



  closeModal(){
    this.closeModalRequest.emit("regStudentModal")
  }
  // reloadHomePage() {
  //   this.router.navigate(["/guardian/show",this.guardian.server_user_id],
  //     {
  //       queryParams: { reload: new Date().getTime() }
  //     }
  //   )

  // }
}
